<template>
  <div id="app">
    <div v-show="showhide">
      <input
        id="username"
        type="text"
        placeholder="User"
        v-model="username"
      /><br />
      <input
        id="userpassword"
        type="password"
        placeholder="Passwort"
        v-model="password"
      /><br />
      <button id="login" @click="saveLogin">Login</button>
    </div>
    <div id="nav" v-show="showhideLinks">
      <router-link :to="{ name: 'EditSurvey' }">Bearbeiten</router-link> |
      <router-link ref="results" :to="{ name: 'Results' }">Auswertung</router-link> |
      <router-link ref="about" :to="{ name: 'About' }">Über</router-link>
    </div>
    <router-view @loggedStatus="callRefresh" />
  </div>
  <div id="confirm"></div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      showhide: true,
      showhideLinks: true
    }
  },
  created() {
    let url = new URL(window.location.href)
    localStorage.origUrl = url
    let mode = url.searchParams.get('mode')
    let username = url.searchParams.get('username')
    let usertoken = url.searchParams.get('usertoken')
    let user_id = parseInt(url.searchParams.get('uid'))
    if(!user_id){
      user_id = parseInt(url.searchParams.get('userid'));
    }
    let username_login = url.searchParams.get('uc');
    let password_login = url.searchParams.get('pc');
    let fromApp = parseInt(url.searchParams.get('fromapp'));
    if(!fromApp){
      fromApp = 0;
    }
    localStorage.fromApp = fromApp;

    if (user_id) {
      localStorage.user_id = user_id
    }
    if (usertoken) {
      localStorage.usertoken = usertoken
    }
    if (username) {
      this.username = username
    } else if (localStorage.username) {
      this.username = localStorage.username
    }
    let password = url.searchParams.get('userpassword')
    if (password) {
      this.password = password
    } else if (localStorage.password) {
      this.password = localStorage.password
    }
    if (this.password !== '' && this.username !== '') {
      localStorage.password = this.password
      localStorage.username = this.username
    }
    if (mode) {
      localStorage.mode = mode;
      if (mode === 'create') {
        if (!usertoken){
          localStorage.usertoken = "";
        }
        localStorage.username = "";
        localStorage.password = "";
        if(username_login != "" && password_login != ""){
          localStorage.username = username_login;
          localStorage.password = password_login;
          window.username = username_login;
          window.password = password_login;
        }
        let survey_id = url.searchParams.get('sid')
        localStorage.survey_id = parseInt(survey_id)
        this.$router.push({ name: 'EditSurvey' })
        localStorage.survey_title = url.searchParams.get('surveyTitle')
        this.showhide = false;
        this.showhideLinks = false;
      } else if (this.password !== '' && this.username !== '') {
        this.$router.push({ name: 'Results' })
      }
    }else{
      this.showhideLinks = false
      if(localStorage.mode == "create"){
        this.showhide = false
        this.showhideLinks = false
      }else if(username_login != "" && password_login != "" && username_login != null && password_login != null){
        this.username = username_login
        this.password = password_login
        this.saveLogin();
      }
      this.showhide = true;
    }
  },
  methods: {
    saveLogin: function() {
      window.username = this.username
      window.password = this.password
      localStorage.username = this.username
      localStorage.password = this.password
      if(this.$route.name == "Results"){
        this.$router.go()
      }else{
        this.$router.push({ name: 'Results' })
      }
    },
    reloadPage: function (){
      this.$router.go()
    }
  },
  mounted() {}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 10px;
}

#login {
  margin-top: 5px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

h4 {
  font-size: 20px;
}
</style>
